import * as types from './types';

export function changePage(data) {
  return {
    type: types.CHANGE_PAGE,
    data
  };
}

export function setResult(data) {
  return {
    type: types.GET_RESULT,
    data
  };
}
